<template>
  <div>
    <table v-if="!isEdit" class="table">
      <tr>
        <th>
          オークション
          <br v-if="!isMobile" />
          種別
          <span class="must">必須</span>
        </th>
        <td>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              :id="`${prefixCd}-aa-radio-1`"
              :value="0"
              v-model.number="isAAFlg"
            />
            <label class="form-check-label" :for="`${prefixCd}-aa-radio-1`">
              その他
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              :id="`${prefixCd}-aa-radio-2`"
              :value="1"
              v-model.number="isAAFlg"
            />
            <label class="form-check-label" :for="`${prefixCd}-aa-radio-2`">
              オークション
            </label>
          </div>
        </td>
      </tr>
    </table>

    <validation-observer ref="directObserver" method="post">
      <table v-if="!isAAFlg" class="table">
        <tr>
          <th>
            名称
            <span class="must">必須</span>
          </th>
          <td>
            <validation-provider
              v-slot="{ errors }"
              rules="required|max:25|char"
              name="MEI"
            >
              <b-form-input
                ref="MEI"
                maxlength="25"
                v-model="other.MEI"
                :state="errors.length ? false : null"
                placeholder="株式会社ロジコ"
                trim
                @blur="other.MEI = replaceChar(other.MEI)"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>郵便番号</th>
          <td>
            <div class="row">
              <div class="col-4">
                <validation-provider
                  v-slot="{ errors }"
                  rules="numeric|digits:3"
                  name="YUBIN1"
                >
                  <b-form-input
                    ref="YUBIN1"
                    type="tel"
                    maxlength="3"
                    v-model="other.YUBIN1"
                    :state="errors.length ? false : null"
                    placeholder="160"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <span class="py-smー2">-</span>
              <div class="col-4">
                <validation-provider
                  v-slot="{ errors }"
                  rules="numeric|digits:4"
                  name="YUBIN2"
                >
                  <b-form-input
                    ref="YUBIN2"
                    type="tel"
                    maxlength="4"
                    v-model="other.YUBIN2"
                    :state="errors.length ? false : null"
                    placeholder="0023"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <button
                type="button"
                class="btn btn-success"
                @click="searchAddress"
                style="height: 40px"
              >
                検索
              </button>
            </div>
          </td>
        </tr>
        <tr v-if="!isAAFlg">
          <th>
            都道府県&ensp;
            <br v-if="isPC" />
            市区町村
            <span class="must">必須</span>
          </th>
          <td>
            <div class="row">
              <div class="col-5">
                <validation-provider
                  name="TODO_CD"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <b-form-select
                    ref="TODO_CD"
                    v-model="other.TODO_CD"
                    :state="errors.length ? false : null"
                    :options="prefList"
                    trim
                    @change="changePref"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <div class="col-7">
                <validation-provider
                  name="SHIKU_CD"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <b-form-select
                    ref="SHIKU_CD"
                    :disabled="!cityList.length"
                    v-model="other.SHIKU_CD"
                    :state="errors.length ? false : null"
                    :options="cityList"
                    trim
                    @change="changeCity"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="!isAAFlg">
          <th>
            番地建物名
            <span class="must">必須</span>
          </th>
          <td>
            <validation-provider
              name="BANCHI"
              v-slot="{ errors }"
              rules="required|max:25|char"
            >
              <b-form-input
                ref="BANCHI"
                maxlength="25"
                v-model="other.BANCHI"
                :state="errors.length ? false : null"
                placeholder="西新宿7－4－3 升本ビル4F"
                trim
                @blur="other.BANCHI = replaceChar(other.BANCHI)"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>
            TEL
            <span class="must">必須</span>
          </th>
          <td>
            <validation-provider v-slot="{ errors }" rules="required|tel">
              <b-form-input
                maxlength="17"
                v-model="other.TEL"
                :state="errors.length ? false : null"
                placeholder="03-5937-4777"
                trim
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>
            担当者名
            <span v-if="isLease" class="must">必須</span>
          </th>
          <td>
            <validation-provider
              name="TANTO_MEI"
              v-slot="{ errors }"
              :rules="`${isLease ? 'required|' : ''}max:20|char`"
            >
              <b-form-input
                ref="TANTO_MEI"
                maxlength="20"
                v-model="other.TANTO_MEI"
                :state="errors.length ? false : null"
                placeholder="山田太郎"
                trim
                @blur="other.TANTO_MEI = replaceChar(other.TANTO_MEI)"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>
            担当者
            <br v-if="isPC" />
            TEL
          </th>
          <td>
            <validation-provider v-slot="{ errors }" rules="max:17|tel">
              <b-form-input
                maxlength="17"
                v-model="other.TANTO_TEL"
                :state="errors.length ? false : null"
                placeholder="090-1234-5678"
                trim
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>種別</th>
          <td>
            <validation-provider v-slot="{ errors }">
              <b-form-select
                v-model="other.YUSO_KBN"
                :state="errors.length ? false : null"
                :options="yusoKbnList"
                trim
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>
            定休日
            <span v-if="isRequiredTeikyubi" class="must">必須</span>
          </th>
          <td>
            <validation-provider
              v-slot="{ errors }"
              :rules="{ required: isRequiredTeikyubi }"
            >
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-1`"
                  v-model="other.TEIKYU_BI"
                  value="月"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-1`">
                  月
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-2`"
                  v-model="other.TEIKYU_BI"
                  value="火"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-2`">
                  火
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-3`"
                  v-model="other.TEIKYU_BI"
                  value="水"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-3`">
                  水
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-4`"
                  v-model="other.TEIKYU_BI"
                  value="木"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-4`">
                  木
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-5`"
                  v-model="other.TEIKYU_BI"
                  value="金"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-5`">
                  金
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-6`"
                  v-model="other.TEIKYU_BI"
                  value="土"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-6`">
                  土
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-7`"
                  v-model="other.TEIKYU_BI"
                  value="日"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-7`">
                  日
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-8`"
                  v-model="other.TEIKYU_BI"
                  value="祝"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-8`">
                  祝
                </label>
              </div>
              <div
                v-if="errors.length"
                class="invalid-feedback"
                style="display: block"
              >
                <span class="border-red">{{ errors[0] }}</span>
              </div>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>営業時間</th>
          <td>
            <div class="row">
              <div class="col-5">
                <select
                  class="form-control form-input"
                  v-model="other.EIGYO_KAISI_JIKAN"
                >
                  <option value="">未選択</option>
                  <option v-for="jikan in time" :value="jikan" :key="jikan">
                    {{ jikan }}
                  </option>
                </select>
              </div>
              <span class="py-smー2 px-0">~</span>
              <div class="col-5">
                <select
                  class="form-control form-input"
                  v-model="other.EIGYO_SYURYO_JIKAN"
                >
                  <option value="">未選択</option>
                  <option v-for="jikan in time" :value="jikan" :key="jikan">
                    {{ jikan }}
                  </option>
                </select>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </validation-observer>

    <validation-observer ref="auctionObserver" method="post">
      <table v-if="isAAFlg" class="table">
        <tr>
          <th>
            オークション
            <br v-if="!isMobile" />
            会場
            <span class="must">必須</span>
          </th>
          <td>
            <div class="row mb-2">
              <label class="d-inline mt-2 ml-3 pr-2">都道府県</label>
              <validation-provider v-slot="{ errors }">
                <b-form-select
                  v-model="searchCond.aa.TODO_CD"
                  :state="errors.length ? false : null"
                  :options="prefList"
                  trim
                  @change="search"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <div>
              <validation-provider v-slot="{ errors }" rules="required">
                <b-form-select
                  v-model="selectedItem"
                  :state="errors.length ? false : null"
                  :options="aaList"
                  :disabled="!aaList.length"
                  trim
                  @change="selectedAA"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </td>
        </tr>
      </table>
    </validation-observer>
  </div>
</template>

<script>
import Store from '@/store/index.js'
import _ from 'lodash'
import Mixin from '../mixin/Mixin'

const HIKINO_SAKI = {
  AA_KAISAI_BI: null,
  YUBIN1: null,
  YUBIN2: null,
  TODO_CD: null,
  TODO_MEI: null,
  SHIKU_CD: '',
  SHIKU_MEI: null,
  BANCHI: null,
  MEI: null,
  TEL: null,
  TANTO_MEI: null,
  TANTO_TEL: null,
  YUSO_KBN: '',
  HCB_ZOKUSEI_CD: null,
  LANDMARK_KBN: null,
  TEIKYU_BI: [],
  EIGYO_KAISI_JIKAN: '',
  EIGYO_SYURYO_JIKAN: '',
  TOROKUBAYO_KO_ID: null,
  HANNYUSYUTU_JIKAN: null,
  AA_CD: null,
  AA_ID: null,
}

const DATA_KBN_AA = 'AUCTION'
const DATA_KBN_DIRECT = 'DIRECT'
export default {
  name: 'DirectOrAuctionEdit',
  mixins: [Mixin],

  props: {
    /** オークション取得フラグ */
    isGetAaFlg: {
      type: Boolean,
      default: false,
    },

    /** 検索条件 */
    _searchCond: {
      type: Object,
      default: null,
    },

    /** 検索実行フラグ */
    isSearch: {
      type: Boolean,
      default: false,
    },

    /** バリデーション実行フラグ */
    isValid: {
      type: Boolean,
      default: false,
    },

    /** 名変フラグ */
    isMeihen: {
      type: Number,
      default: 0,
    },

    /** 引取先フラグ */
    isHikitori: {
      type: Boolean,
      default: false,
    },

    /** 編集フラグ */
    isEdit: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    /** オークション入力データ */
    aa: _.cloneDeep(HIKINO_SAKI),

    /** 直接入力データ */
    other: _.cloneDeep(HIKINO_SAKI),

    isLoading: {
      aa: false,
      other: false,
    },

    /** 市区町村リスト */
    cityList: [],

    /** オークション表示フラグ */
    isAAFlg: 0,

    /** 検索条件 */
    searchCond: {
      direct: {
        TODO_CD: null,
        SHIKU_CD: null,
      },
      aa: {
        TODO_CD: null,
      },
    },

    /** オークションリスト */
    aaList: [],

    /** オークション選択データ*/
    selectedItem: null,

    /** ラジオ、チェックボックスに利用するIDのprefix */
    prefixCd: Math.random().toString(32).substring(2),
  }),

  methods: {
    /** バリデーション実行 */
    validate() {
      this.$v.$touch()
    },

    /** オークション引取先選択 */
    selectedAA() {
      const item = this.selectedItem
      if (!item) {
        return this.$emit('setData', {}, DATA_KBN_AA)
      }
      const data = {
        AA_KAISAI_BI: null,
        AA_CD: item.AA_CD,
        AA_ID: item.id,
        TOROKUBAYO_KO_ID: null,
        YUBIN1: item.YUBIN_BANGO1,
        YUBIN2: item.YUBIN_BANGO2,
        TODO_CD: item.TODO_CD,
        TODO_MEI: item.TODO_MEI,
        SHIKU_CD: item.SHIKU_CD,
        SHIKU_MEI: item.SHIKU_MEI,
        BANCHI: item.BANCHI,
        MEI: item.name,
        TEL: item.HCB_TEL || item.TEL,
        YUSO_KBN: null,
        HCB_ZOKUSEI_CD: item.HCB_ZOKUSEI_CD,
        LANDMARK_KBN: null,
        TANTO_MEI: null,
        TANTO_TEL: null,
        TEIKYU_BI: null,
        EIGYO_KAISI_JIKAN: null,
        EIGYO_SYURYO_JIKAN: null,
        HANNYUSYUTU_JIKAN: null,
        OKINIIRI_FLG: this.aa.OKINIIRI_FLG,
      }
      this.$emit('setData', data, DATA_KBN_AA)
    },

    /** オークション入力データを初期化する */
    reset() {
      this.aaList = []
      this.selectedItem = null
      this.$emit('reset', DATA_KBN_AA)
    },

    /** 検索する */
    async search() {
      this.reset()
      await this.getAAList()
    },

    /** 郵便番号検索 */
    async searchAddress() {
      this.isLoading.other = true
      await this.getAreaFromZipCd(`${this.other.YUBIN1}${this.other.YUBIN2}`)
        .then(async (item) => {
          if (item) {
            this.other.TODO_CD = ('00' + item.prefcode).slice(-2)
            this.other.TODO_MEI = this.getText(
              this.prefList,
              this.other.TODO_CD
            )
            this.other.SHIKU_MEI = item.address2
            this.other.BANCHI = item.address3
            await this.getCityList(this.other.TODO_CD)
            const city = this.getParam(
              this.cityList,
              this.other.SHIKU_MEI,
              'text'
            )
            if (city) this.other.SHIKU_CD = city.value
          }
        })
        .catch(() =>
          this.$nuxt.$emit('snackBarError', '住所の取得に失敗しました')
        )
      this.isLoading.other = false
    },

    /** 都道府県変更 */
    changePref() {
      const todoCd = this.other.TODO_CD
      this.other.TODO_MEI = null
      this.other.SHIKU_CD = ''
      this.other.SHIKU_MEI = null
      if (todoCd) {
        this.other.TODO_MEI = this.getText(this.prefList, todoCd)
        this.getCityList(this.other.TODO_CD)
      } else this.cityList = []
    },

    /** 市区町村変更 */
    changeCity() {
      const shikuCd = this.other.SHIKU_CD
      this.other.SHIKU_MEI = null
      if (shikuCd) {
        this.other.SHIKU_MEI = this.getText(this.cityList, shikuCd)
      }
    },

    /** 市区町村リスト取得 */
    getCityList(todoCd) {
      if (!todoCd) return
      this.isLoading.other = true
      return Store.dispatch('address/getCityList', todoCd).then(() => {
        const cityList = _.cloneDeep(Store.state.address.cityList)
        cityList.unshift({
          value: '',
          text: '未選択',
        })
        this.cityList = cityList
        this.isLoading.other = false
      })
    },

    /** オークションリスト取得 */
    getAAList() {
      this.isLoading.aa = true
      const prefCd =
        this.searchCond.aa.TODO_CD !== '' ? this.searchCond.aa.TODO_CD : null
      return this.getAuctions(prefCd).then((res) => {
        this.aaList = res.data.map((v) => {
          return {
            value: v,
            text: v.name,
          }
        })
        this.aaList.unshift({ text: '未選択', value: null })
        this.isLoading.aa = false
      })
    },

    /** オークションフラグの設定を親に伝える */
    callSetIsAAflg() {
      this.$emit('setIsAAFlg', this.isAAFlg, DATA_KBN_DIRECT)
    },

    /** オークション状況を再現する */
    async revivalAA() {
      const cond = this._searchCond.aa
      this.searchCond.aa.TODO_CD = cond.TODO_CD
      await this.search()
      const item = this.aaList.filter(
        (v) =>
          v.value && (v.value.id === cond.AA_ID || v.value.AA_CD === cond.AA_CD)
      )[0]
      if (item) {
        this.selectedItem = item.value
        this.selectedAA()
      }
    },

    /** 直接編集入力状況を再現する */
    async revivalDirect() {
      this.getCityList(this._searchCond.other.TODO_CD)
      await this.sleep(100)
      this.other = _.merge(this.other, this._searchCond.other)
      this.$emit('setData', _.cloneDeep(this.other), DATA_KBN_DIRECT)
    },
  },

  computed: {
    /** 定休日が必須かどうか判定する */
    isRequiredTeikyubi() {
      return this.isMeihen === 1 && this.isHikitori
    },
  },

  watch: {
    /** ローディングフラグ */
    isLoading: {
      handler(val) {
        this.$emit('loaded', val.aa || val.other, DATA_KBN_DIRECT)
      },
      deep: true,
    },

    /** 直接編集入力データ */
    other: {
      handler(val) {
        this.$emit('setData', val, DATA_KBN_DIRECT)
      },
      deep: true,
    },

    /** オークションフラグ監視 */
    isAAFlg(val) {
      this.callSetIsAAflg()
    },

    /** オークション取得フラグ監視 */
    isGetAaFlg(val) {
      if (val) this.callSetIsAAflg()
    },

    /** 検索実行フラグ */
    async isSearch(val) {
      if (val) {
        if (this._searchCond.isAAFlg !== undefined) {
          this.isAAFlg = Number(this._searchCond.isAAFlg)
          this.callSetIsAAflg()
        }

        if (this._searchCond.other) this.revivalDirect()
        else this.other = _.cloneDeep(HIKINO_SAKI)

        if (this._searchCond.aa) this.revivalAA()
        else await this.search()

        this.$emit('searched', DATA_KBN_DIRECT)
      }
    },

    /** バリデーション実行フラグ */
    async isValid(val) {
      if (val) {
        const invalid = this.isAAFlg
          ? await this.$refs.auctionObserver.validate()
          : await this.$refs.directObserver.validate()
        this.$emit('setInvalid', !invalid, DATA_KBN_DIRECT, this.isAAFlg)
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.table-wrapper
  overflow: auto
  //height: 780px
  @include sp
    overflow: hidden
    height: auto
    max-height: 100%
.form-check-inline
  margin-right: 5px
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
  td
    width: 68%
</style>


// WEBPACK FOOTER //
// src/components/order/DirectOrAuctionEdit.vue